<template>
  <div>
    <div class="vx-col w-full">
      <ul class="heading-ul mt-2 mb-3">
        <li>
          <router-link to="/shift-management" class="vx-row">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("setup.label.CreateShift") }}</h4>
          </router-link>
        </li>
      </ul>
    </div>
    <ValidationObserver ref="observer">
      <div class="vx-row">
        <vx-card>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="shift name"
              >
                <vs-input
                  :label="$t('setup.label.ShiftName')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="shiftName"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="description"
              >
                <vs-input
                  :label="$t('setup.label.Description')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="description"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div
            class="vx-row mt-1"
            v-for="(session, index) in sessions"
            :key="index"
          >
            <div class="vx-col w-full md:w-1/4 sm:w-1/2">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.Session") }}
                  <span class="required">*</span></small
                >
                <v-select
                  label="mCodeValue"
                  :options="sessionList || []"
                  v-model="session.sessionName"
                  :reduce="(obj) => obj.mCodeValue"
                  placeholder="Select session"
                  class="w-full"
                />
              </div>
            </div>

            <div class="vx-col w-full md:w-1/4 sm:w-1/2">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.SessionStartTime") }}
                  <span class="required">*</span></small
                >
                <flat-pickr
                  :config="configdateTimePicker"
                  class="w-full"
                  v-model="session.startTime"
                />
              </div>
            </div>

            <div class="vx-col w-full md:w-1/4 sm:w-1/2">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.SessionEndTime") }}
                  <span class="required">*</span></small
                >
                <flat-pickr
                  :config="configdateTimePicker"
                  class="w-full"
                  v-model="session.endTime"
                />
              </div>
            </div>

            <div
              class="vx-col w-full md:w-1/4 sm:w-1/2 flex items-center gap-2"
            >
              <vs-button
                color="danger"
                icon="icon-trash"
                icon-pack="feather"
                @click="removeSession(index)"
                type="filled"
              >
                {{ $t("setup.label.Remove") || "Remove" }}
              </vs-button>

              <vs-button
                v-if="index === sessions.length - 1"
                color="primary"
                icon="icon-plus"
                icon-pack="feather"
                @click="addSession"
                type="filled"
              >
                {{ $t("setup.label.Add") }}
              </vs-button>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="cancel"
            >{{ $t("setup.label.Cancel") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="createTeamData"
            >{{ $t("setup.label.Submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import ValidationPopup from "@/components/ValidationPopup.vue";

export default {
  data() {
    return {
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      description: "",
      shiftName: "",
      configdateTimePicker: {
        enableTime: true,
        noCalendar: true,
        enableSeconds: true,
        time_24hr: true,
        dateFormat: "H:i:S",
      },
      sessions: [],
    };
  },
  components: {
    "v-select": vSelect,
    "validation-popup": ValidationPopup,
    ValidationProvider,
    ValidationObserver,
    flatPickr,
  },
  computed: {
    ...mapState({
      sessionList: (state) => state.shiftManagement.sessionList,
    }),
  },
  methods: {
    removeSession(index) {
      this.sessions.splice(index, 1);
    },
    addSession() {
      const lastSession = this.sessions[this.sessions.length - 1];
      if (
        lastSession &&
        (!lastSession.sessionName ||
          !lastSession.startTime ||
          !lastSession.endTime)
      ) {
        this.$vs.notify({
          title: "Incomplete Entry",
          text: "Please fill all the details before adding a new one.",
          color: "warning",
        });
        return;
      }
      this.sessions.push({
        sessionName: null,
        startTime: "",
        endTime: "",
      });
    },
    async createTeamData() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      const validSessions = this.sessions.filter(
        (session) => session.sessionName && session.startTime && session.endTime
      );

      if (validSessions.length === 0) {
        this.$swal({
          title: "Error",
          icon: "error",
          text: "Please add at least one complete session!",
          type: "error",
        });
        return;
      }
      const payload = {
        sessionConfigurations: validSessions.map((session) => ({
          NAME: this.shiftName,
          DESCRIPTION: this.description,
          SESSION_TYPE: session.sessionName,
          START_TIME: session.startTime,
          END_TIME: session.endTime,
          IS_ACTIVE: true,
        })),
      };
      try {
        await this.$store.dispatch(
          "shiftManagement/createShiftAction",
          payload
        );
        if (this.sessionList) {
          this.$swal({
            title: "Success",
            icon: "success",
            text: "Shift Created Successfully!",
            type: "success",
          });
          this.$router.push(`/shift-management`);
        }
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    async getSessionMcodesMethod() {
      try {
        await this.$store.dispatch("shiftManagement/getSessionMcodesAction");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    cancel() {
      this.$router.push(`/shift-management`);
    },
  },
  watch: {},
  async mounted() {
    if (this.sessions.length === 0) {
      this.addSession();
    }
    await this.getSessionMcodesMethod();
  },
};
</script>
